import FilesViewer from './ViewerContainer';

export default FilesViewer;
